import theme from '~/src/shared/styles/theme/shared_theme'

export { tbPalette } from '~/src/shared/styles/theme/palette'
export default theme
